'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const client = require('./client');

import Avatar from 'material-ui/Avatar';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import Popover from 'material-ui/Popover/Popover';
import FlatButton from 'material-ui/FlatButton';
import Container from 'muicss/lib/react/container';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';

import {
	  Table,
	  TableBody,
	  TableHeader,
	  TableHeaderColumn,
	  TableRow,
	  TableRowColumn,
	} from 'material-ui/Table';

export default class TableauNav extends React.Component {
	
	constructor(props) {
		super(props);
	
		this.state = {
			dossierInstance:"Sales Funnel",
			itemValue: 0,
			viewValue: "",
			items: [],
			open: false
	    };
		this.mTable ={};
		this.currentView = 0;
		
		this.changeFilter = this.changeFilter.bind(this);
		this.changeView = this.changeView.bind(this);
		this.changeViewTable = this.changeViewTable.bind(this);
		this.updateFilterElements = this.updateFilterElements.bind(this);
		this.handleRequestClose = this.handleRequestClose.bind(this);
		this.handleClick = this.handleClick.bind(this);
		
		
		this.items = [];
		this.items.push(<MenuItem value={0} key={0} style={{color: 'white', backgroundColor: '#424448'}} primaryText={'All'} />);
		this.items.push(<MenuItem value={1} key={1} style={{color: 'white', backgroundColor: '#424448'}} primaryText={'Q1'} />);
		this.items.push(<MenuItem value={2} key={2} style={{color: 'white', backgroundColor: '#424448'}} primaryText={'Q2'} />);
		this.items.push(<MenuItem value={3} key={3} style={{color: 'white', backgroundColor: '#424448'}} primaryText={'Q3'} />);
		this.items.push(<MenuItem value={4} key={4} style={{color: 'white', backgroundColor: '#424448'}} primaryText={'Q4'} />);

		
		this.views = [];
		this.views.push(<MenuItem value={"Overview"} key={1} primaryText={"Overview"} />);
		this.views.push(<MenuItem value={"Sales"} key={2} primaryText={"Sales"} />);
		this.views.push(<MenuItem value={"Service"} key={3} primaryText={"Service"} />);
	}
	
	updateFilterElements(items){
		var newItems = [];
		Object.keys(items).forEach(function (entry){
			var ltest = "";
			ltest= <MenuItem value={parseInt(entry)} key={parseInt(entry)} style={{color: 'white', backgroundColor: '#424448'}} primaryText={'Store ' +entry } />;
			newItems.push(ltest);
		}); 
		
		this.setState({itemValue:parseInt(Object.keys(items)[0]) , items: newItems});
	}
	
	changeFilter(e, index, selection){
		this.setState({itemValue: e});
		this.props.app.mTableauEmbedded.changeFilter(index);
	}
	
	changeView(e, index, selection) {
		this.setState({viewValue: selection});
		this.props.app.mTableauEmbedded.changeViz(selection);
	}
	
	changeViewTable(e, index, selection) {
		if(index != this.currentView){
			var lTest = 0;
			this.currentView = index;
			if(index == 0){
				this.props.app.mTableauEmbedded.changeViz("SUMMARY");
			}else if(index == 1){
				this.props.app.mTableauEmbedded.changeViz("PURCHASE ORDERS");
			}else{
				this.props.app.mTableauEmbedded.changeViz("SALES INSIGHT");
			}
			this.setState({viewValue: index})
		}
	}
	
	componentDidUpdate() {

	}

	componentDidMount() {
		
        
	}
	
	handleRequestClose() {
	    this.setState({
	      open: false,
	    });
	}
	
	handleClick(event) {
	    event.preventDefault();

	    this.setState({
	      open: true,
	      anchorEl: event.currentTarget
	    });
	}
	
	render() {
		return (
				<div className="tableauNav" style={{fontSize: "20px", color: "#121047", backgroundColor:"white", textAlign: "center", width: "100%", height:"45px"}} >
				  <div style={{display: "table", textAlign:"left", float: "left", width: "550px", marginLeft: '18px'}}>
				  	<div style={{height:"45px", width:"190px", display: "table-cell", verticalAlign: "middle"}}>BROKER PORTAL &gt;</div>
				  	<div style={{height:"45px", display: "table-cell", verticalAlign: "middle"}}>{this.state.dossierInstance}</div>
				  </div>
				  <div style={{display: "table", marginRight: "19px", float: "right", width: "607px"}}>
				  	<div style={{height:"45px", display: "table-cell", verticalAlign: "middle"}}>Line of Business:</div>
				  	<FlatButton
						hoverColor="white"
						backgroundColor="white"
						labelStyle={{fontSize: '16px', color:this.state.itemValue==0? "#121047":"#a5bcd3"}}
						labelPosition="after"		
				      	label="Home"
				      	icon={this.state.itemValue==0?
				      			<img src={"./img/home_selected.png"} height= "26px" style={{textAlign: "center"}} />
				      			:
				      			<img src={"./img/home_unselected.png"} height= "26px" style={{textAlign: "center"}} />
				  			}
				      	style={{height:"45px", width: '150px', minWidth: '20px'}}
				  		onClick={this.changeFilter.bind(this, 0, "Home")}
				     />
					 <FlatButton
						hoverColor="white"
						backgroundColor="white"
						labelStyle={{fontSize: '16px', color:this.state.itemValue==1? "#121047":"#a5bcd3"}}
						labelPosition="after"		
				      	label="Auto"
				      	icon={this.state.itemValue==1?
				      			<img src={"./img/auto_selected.png"} height= "26px" style={{textAlign: "center"}} />
				      			:
				      			<img src={"./img/auto_unselected.png"} height= "26px" style={{textAlign: "center"}} />
				  			}
				  		style={{height:"45px", width: '150px', minWidth: '20px'}}
			  			onClick={this.changeFilter.bind(this, 1, "Auto")}
				     />				     
					 <FlatButton
						hoverColor="white"
						backgroundColor="white"
						labelStyle={{fontSize: '16px', color:this.state.itemValue==2? "#121047":"#a5bcd3"}}
						labelPosition="after"		
				      	label="Health"
				      	icon={this.state.itemValue==2?
				      			<img src={"./img/health_selected.png"} height= "26px" style={{textAlign: "center"}} />
				      			:
				      			<img src={"./img/health_unselected.png"} height= "26px" style={{textAlign: "center"}} />
				  			}
				      	style={{height:"45px", width: '150px', minWidth: '20px'}}
				  		onClick={this.changeFilter.bind(this, 2, "Health")}
				     />
				  </div>
			  	</div>
			)
	}
}


// WEBPACK FOOTER //
// ./src/main/js/TableauNav.js